import React, {Component} from 'react';
import Attachments from './Attachments';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import {Parser} from 'html-to-react';
import {BASENAME} from '../../constants';
import '../App.css';

import Loader from 'react-loader';

import ArtifactDialog from './ArtifactDialog';

import {withStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import grey from '@material-ui/core/colors/grey';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';


const styles = theme => ({
    title: {
        color: 'black',
        fontSize: 'x-large',
        fontWeight: 'bold',
        backgroundColor: grey[200],
        padding: 16
    },
    table: {
        // marginTop: 10
    },
    tr: {},
    td: {
        borderTop: '1px solid #dddddd',
        // textAlign: 'center',
        padding: 5
    },
    th: {
        borderTop: '1px solid #dddddd',
        // textAlign: 'center',
        padding: 5
    },
    card: {
        minWidth: 275,
        marginBottom: 30
    },
    cardContent: {
        paddingTop: 10
    },
    correct: {
        color: 'black',
        backgroundColor: green[200]
    },
    incorrect: {
        color: 'black',
        backgroundColor: red[200]
    },
    partial: {
        color: 'black',
        backgroundColor: green[50]
    },
    indent: {
        marginLeft: 10
    },
    b: {
        fontWeight: 'bold',
        fontSize: 'large'
    }
});

class QuizRender extends Component {
    _isMounted = false;
    htmlToReactParser = new Parser();

    QUESTION_TYPES = {
        MULTIPLE_CHOICE_QUESTION: "multiple_choice_question",
        TEXT_ONLY_QUESTION: "text_only_question",
        FILE_UPLOAD_QUESTION: "file_upload_question",
        ESSAY_QUESTION: "essay_question",
        CALCULATED_QUESTION: "calculated_question",
        NUMERICAL_QUESTION: "numerical_question",
        MATCHING_QUESTION: "matching_question",
        MULTIPLE_DROPDOWNS_QUESTION: "multiple_dropdowns_question",
        MULTIPLE_ANSWERS_QUESTION: "multiple_answers_question",
        FILL_IN_MULTIPLE_BLANKS_QUESTION: "fill_in_multiple_blanks_question",
        SHORT_ANSWER_QUESTION: "short_answer_question",
        TRUE_FALSE_QUESTION: "true_false_question"
    };

    constructor(props) {
        super(props);
        this.state = {
            questions: [],
            answers: [],
            questionsAttachments: [],
            loaded: true
        };
    }

    onStart = () => {
        this.setState({loaded: false});
    };

    onSuccess = ({questions, answers, questionsAttachments}) => {
        if(this._isMounted) {
            this.setState({
                questions,
                answers,
                questionsAttachments,
                loaded: true
            });
        }
    };

    onError = (err) => {
        this.setState({
            questions: [],
            answers: []
        });
        // handle error here
        console.log(err);
    };

    fetchQuestions = async (canvas_course_id, canvas_quiz_id) => {
        const res = await fetch(BASENAME + '/api/quiz/questions/' + canvas_course_id + "/" + canvas_quiz_id);
        const questions = await res.json();
        return questions; // && questions[0].quiz_id ? questions: [];
    };

    fetchQuizBankQuestions = async(canvas_submission_id)=>{
        const res = await fetch(BASENAME + '/api/quiz_questions_by_submission/' +canvas_submission_id);
        const questions = await res.json();
        return questions;
    };

    fetchAnswers = async (canvas_course_id, canvas_assignment_id, canvas_user_id) => {
        const res = await fetch(BASENAME + '/api/quiz/answers/' + canvas_course_id + "/" + canvas_assignment_id + "/" + canvas_user_id);
        const answers = await res.json();
        return answers;// && answers[0].question_id ? answers : [];
    };

    fetchFile = async (canvas_file_id) => {
        const res = await fetch(BASENAME + '/api/file/' + canvas_file_id);
        const file = await res.json();
        return file;
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        try {
            // quiz id is from assignment obj
            let allQuestions = await this.fetchQuestions(this.props.submission.canvas_course_id, this.props.submission.canvas_quiz_id);
            if(allQuestions.length==0){
                allQuestions = await this.fetchQuizBankQuestions(this.props.submission.canvas_submission_id)
            }
            const allAnswers = await this.fetchAnswers(this.props.submission.canvas_course_id, this.props.submission.canvas_assignment_id, this.props.submission.canvas_user_id);
            // filter it down by result of randomized artifacts
            const selectedQuestionIds = this.props.submission.canvas_questions.map(question => question.canvas_question_id);
            const questions = allQuestions.filter(question => selectedQuestionIds.find(selectedQuestionId => question.id === selectedQuestionId));
            const answers = allAnswers.filter(answer => selectedQuestionIds.find(selectedQuestionId => answer.question_id === selectedQuestionId));
            // find any uploaded files in quiz questions
            const questionsAttachments = await Promise.all(answers
                .filter(answer => answer.attachment_ids)
                .map(async answer => {
                    const attachments = await Promise.all(answer.attachment_ids.map(async attachment_id => {
                        return await this.fetchFile(attachment_id);
                    }));
                    const questionAttachment = {question_id: answer.question_id, attachments: attachments};
                    return questionAttachment;
                }));
            this.onSuccess({questions, answers, questionsAttachments});
        } catch (err) {
            this.onError(err);
        }

    }

    renderDescription() {
        return (
            <div>
                <h1>{this.props.submission.canvas_assignment_name}</h1>
                <hr/>
                <h2>Assignment Description</h2>
                <h3>
                    {this.htmlToReactParser.parse(this.props.submission.canvas_assignment_description.replace(/(\\r\\n|\\n|\\r)/gm," "))}
                </h3>
                <hr/>

            </div>
        );
    }

    renderMultipleAnswers(question, studentAnswer) {
        const rows = question.answers.map((possibleAnswer, index) => {
            const stAnswered = studentAnswer.answer_id === possibleAnswer.id ?
                <b>&lt;-- Student Answered</b> : null;
            const correct = possibleAnswer.weight === 100 ?
                <b className={this.props.classes.correct}>Correct! ----&gt;</b> : null;
            return (
                <tr key={possibleAnswer.id}>
                    <td className={this.props.classes.td}>{index + 1}.</td>
                    <td className={this.props.classes.td}>{correct}</td>
                    <td className={this.props.classes.td}>{possibleAnswer.text}</td>
                    <td className={this.props.classes.td}>{stAnswered}</td>
                </tr>
            );
        });

        return (
            <table className={this.props.classes.table}>
                <tbody>
                {rows}
                </tbody>
            </table>
        );
    }

    renderFileUploadQuestion(studentAnswer) {
        const attachments = this.state.questionsAttachments.filter(questionAttachment => questionAttachment.question_id === studentAnswer.question_id)[0].attachments;
        const submission = {...this.props.submission, attachments};

        const artifact = <Attachments submission={submission}/>;
        return (
            <div>
                <b>Student uploaded files:</b>
                <div>{artifact}</div>
            </div>
        );
    }

    renderEssayQuestion(studentAnswer) {
        const renderedAnswer = this.htmlToReactParser.parse(studentAnswer.text);
        return (
            <div>
                <b>Student answered:</b>
                <div>{renderedAnswer}</div>
            </div>
        );
    }

    renderCalculatedQuestion(question, studentAnswer) {
        const correctAnswer = question.answers.filter(answer => answer.id === studentAnswer.answer_id)[0];
        const correctAnswerValue = correctAnswer ? correctAnswer.answer :
            <span>Error: couldn't find correct answer!</span>;
        const vars = (correctAnswer && correctAnswer.variables) ? correctAnswer.variables
                .map(variable => <span key={variable.name}>[{variable.name}] = {variable.value}, </span>) :
            <span>Error: couldn't match variable value!</span>;
        return (
            <div>
                <div>Variables:
                    <div className={this.props.classes.indent}>{vars}</div>
                </div>
                <div className={this.props.classes.correct}>Correct answer: {correctAnswerValue}</div>
                <div>Student answered:{studentAnswer.text}</div>
            </div>
        );
    }

    renderMatchingQuestion(question, studentAnswer) {
        const renderedPossibleMatches = (
            <ul>
                {question.matches.map(match => <li key={match.match_id}>{match.text}</li>)}
            </ul>
        );

        const rows = question.answers.map((possibleAnswer, index) => {
            const studentAnswerIdKey = "answer_" + possibleAnswer.id;
            const studentRightMatchId = parseInt(studentAnswer[studentAnswerIdKey]);
            const studentRightMatchText = studentRightMatchId ? question.matches.filter(match => studentRightMatchId === match.match_id)[0].text : null;
            const correct = studentRightMatchId === possibleAnswer.match_id ?
                <b className={this.props.classes.correct}>Correct! ----&gt;</b> :
                <b className={this.props.classes.incorrect}>Incorrect! ----&gt;</b>;
            return (
                <tr className={this.props.classes.tr} key={possibleAnswer.id}>
                    <td className={this.props.classes.td}>{index + 1}.</td>
                    <td className={this.props.classes.td}>{correct}</td>
                    <td className={this.props.classes.td}>{possibleAnswer.left}</td>
                    <td className={this.props.classes.td}>{possibleAnswer.right}</td>
                    <td className={this.props.classes.td}>{studentRightMatchText} </td>
                </tr>
            );
        });

        return (
            <div>
                <h4>All possible right matches:</h4>
                <div>{renderedPossibleMatches}</div>
                <h4>Student answered:</h4>
                <table>
                    <tbody>
                    <tr className={this.props.classes.tr}>
                        <th className={this.props.classes.th}></th>
                        <th className={this.props.classes.th}></th>
                        <th className={this.props.classes.th}>Left</th>
                        <th className={this.props.classes.th}>Right</th>
                        <th className={this.props.classes.th}>Student Match</th>
                    </tr>
                    {rows}
                    </tbody>
                </table>
            </div>
        );
    }

    //test here to show what correct answer highlighting will look like
    renderFillInMultipleBlanksQuestion(question, studentAnswer) {
        const rows = question.answers.map(possibleAnswer => {
            let borderColor = grey[200];
            let stAnswered = null;
            const studentAnswerIdKey = "answer_id_for_" + possibleAnswer.blank_id;
            const studentAnswerID = studentAnswer[studentAnswerIdKey];
            if(possibleAnswer.weight == 100){
                stAnswered = <b><CheckIcon style={{fontSize:'medium', color:'green', float:'right', marginRight:'5px'}}/></b>;
            }
            if(possibleAnswer.id == studentAnswerID){
                if(possibleAnswer.weight==100){
                    borderColor = green[200];
                }else{
                    borderColor=red[200];
                    stAnswered=<b><ClearIcon style={{fontSize:'medium', color:'red', float:'right', marginRight:'5px'}}/></b>;
                }
            }
            const answer = <span>[{possibleAnswer.blank_id}] = {possibleAnswer.text}</span>;
            return (
                <tr className={this.props.classes.tr} key={possibleAnswer.id}>
                    <td style={{border:`solid 2px ${borderColor}`, borderRadius:'3px', width:'270px'}}>{answer}{stAnswered}</td>
                </tr>

            );
        });
        return (
            <table>
                <tbody>
                {rows}
                </tbody>
            </table>
        );
    }

    renderMultipleAnswersQuestion(question, studentAnswer) {
        const rows = question.answers.map(possibleAnswer => {
            const studentAnswerIdKey = "answer_" + possibleAnswer.id;
            const correct = possibleAnswer.weight === 100 ?
                <b className={this.props.classes.correct}>"Correct! ----></b> : null;
            const answer = possibleAnswer.text;
            const stAnswered = studentAnswer[studentAnswerIdKey] && studentAnswer[studentAnswerIdKey] === "1" ?
                <b>&lt;---- Student Answered</b> : null;
            return (
                <tr key={possibleAnswer.id}>
                    <td className={this.props.classes.td}>{correct}</td>
                    <td className={this.props.classes.td}>{answer}</td>
                    <td className={this.props.classes.td}>{stAnswered}</td>
                </tr>
            );
        });
        return (
            <table>
                <tbody>
                {rows}
                </tbody>
            </table>
        );
    }

    renderNumericalQuestion(question, studentAnswer) {
        const correctAnswer = question.answers.filter(answer => answer.id === studentAnswer.answer_id)[0];
        let correctAnswerRendered = <span>Error: Numerical answer type not found!</span>;
        if (correctAnswer && correctAnswer.numerical_answer_type) {
            switch (correctAnswer.numerical_answer_type) {
                case "range_answer":
                    correctAnswerRendered = <span>Between {correctAnswer.start} and {correctAnswer.end}</span>;
                    break;
                case "exact_answer":
                    correctAnswerRendered =
                        <span>Exact value = {correctAnswer.exact} with margin = {correctAnswer.margin}</span>;
                    break;
                case "precision_answer":
                    correctAnswerRendered =
                        <span>Approximate value = {correctAnswer.approximate} with precision = {correctAnswer.precision}</span>;
                    break;
            }
        }

        return (
            <div>
                <span className={this.props.classes.correct}>Correct answer: {correctAnswerRendered}</span>
                <br/>
                <span>Student answered:{studentAnswer.text}</span>
            </div>
        );
    }

    renderByQuestionType(question) {
        const studentAnswer = this.state.answers.filter(answer => answer.question_id === question.id)[0];
        if (!studentAnswer) {
            console.log("Error: couldn't match student answer to the question!");
            return <div>"Error: couldn't match student answer to the question!"</div>;
        }

        let mappedAnswers = null;
        switch (question.question_type) {
            case this.QUESTION_TYPES.MULTIPLE_CHOICE_QUESTION:
            case this.QUESTION_TYPES.TRUE_FALSE_QUESTION:
            case this.QUESTION_TYPES.SHORT_ANSWER_QUESTION:
                mappedAnswers = this.renderMultipleAnswers(question, studentAnswer);
                break;

            case this.QUESTION_TYPES.FILE_UPLOAD_QUESTION:
                mappedAnswers = this.renderFileUploadQuestion(studentAnswer);
                break;

            case this.QUESTION_TYPES.ESSAY_QUESTION:
                mappedAnswers = this.renderEssayQuestion(studentAnswer);
                break;

            case this.QUESTION_TYPES.CALCULATED_QUESTION:
                mappedAnswers = this.renderCalculatedQuestion(question, studentAnswer);
                break;

            case this.QUESTION_TYPES.NUMERICAL_QUESTION:
                // TODO:
                mappedAnswers = this.renderNumericalQuestion(question, studentAnswer);
                break;

            case this.QUESTION_TYPES.MATCHING_QUESTION:
                mappedAnswers = this.renderMatchingQuestion(question, studentAnswer);
                break;

            case this.QUESTION_TYPES.MULTIPLE_DROPDOWNS_QUESTION:
            case this.QUESTION_TYPES.FILL_IN_MULTIPLE_BLANKS_QUESTION:
                mappedAnswers = this.renderFillInMultipleBlanksQuestion(question, studentAnswer);
                break;

            case this.QUESTION_TYPES.MULTIPLE_ANSWERS_QUESTION:
                mappedAnswers = this.renderMultipleAnswersQuestion(question, studentAnswer);
                break;

            case this.QUESTION_TYPES.TEXT_ONLY_QUESTION:
                // do nothing, this will render question text only
                mappedAnswers = null;
                break;

            default:
                // not found show generic rendering
                console.log("QUESTION NOT FOUND!");
                console.log("studentAnswer: ", JSON.stringify(studentAnswer));
                console.log("question: ", JSON.stringify(question));
                mappedAnswers = (
                    <div>{JSON.stringify(studentAnswer)}</div>
                );
        }

        const questionTextRendered = this.htmlToReactParser.parse(question.question_text);
        const questionTypeRendered = question.question_type.replace(/_/g, " ");
        let correctness = null;
        switch (studentAnswer.correct) {
            case true:
                correctness = <span className={this.props.classes.correct}>Student answered correctly</span>;
                break;
            case false:
                correctness = <span className={this.props.classes.incorrect}>Student answered incorrectly</span>;
                break;
            case "partial":
                correctness = <span className={this.props.classes.partial}>Student answer is partially correct</span>;
                break;
            case "defined":
            case "undefined":
                correctness = null;
                break;
            case "no_score":
                correctness = <span>Not scored</span>;
                break;
            default:
                correctness = <span>Unknown correctness: {studentAnswer.correct}</span>;
        }

        const answers = mappedAnswers ? <div><b className={this.props.classes.b}>Answers:</b>
            <div>{mappedAnswers}</div>
        </div> : null;
        return (
            <Card className={this.props.classes.card} key={question.id}>
                <Typography className={this.props.classes.title} color="textSecondary" gutterBottom>
                    {question.question_name}
                    <br/>({questionTypeRendered})
                </Typography>
                <CardContent key={question.id}>
                    <b className={this.props.classes.b}>Question:</b>
                    <div>{questionTextRendered}</div>
                    <br/>

                    {answers}

                    <p>{correctness}</p>
                </CardContent>
            </Card>
        );

    }

    renderQuestionsAnswers() {
        return this.state.questions.map(question => this.renderByQuestionType(question));
    }

    renderQuiz() {
        return (
            <div className="App">
                <div>{this.renderDescription()}</div>
                <div>{this.renderQuestionsAnswers()}</div>
                <Loader loaded={this.state.loaded}/>
            </div>
        );
    }

    render() {
        return (
            <ArtifactDialog title="Quiz Artifact" isReviewed={this.props.isReviewed} submission={this.props.submission}>
                {this.renderQuiz()}
            </ArtifactDialog>
        )
    }
}

export default withMobileDialog()(withStyles(styles)(QuizRender));

